export const DIRECTION_BI = 1; // Aloware <=> HubSpot
export const DIRECTION_INBOUND = 2; // Aloware <= HubSpot
export const DIRECTION_OUTBOUND = 3; // Aloware => HubSpot
